import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiSadFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 1.333C3.167 1.333 1.333 3.167 1.333 16S3.167 30.667 16 30.667 30.667 28.833 30.667 16 28.833 1.333 16 1.333m-3.392 21.928c-.49.523-.742 1.124-.742 1.739h-2.4c0-1.307.543-2.478 1.392-3.381 1.224-1.304 3.102-2.086 5.142-2.086s3.918.782 5.142 2.085c.848.904 1.391 2.075 1.391 3.382h-2.4c0-.615-.25-1.216-.74-1.739-.723-.769-1.943-1.328-3.393-1.328s-2.67.559-3.392 1.328m10.725-9.394H18v-2.4h5.333zm-14.666 0H14v-2.4H8.666z"
            fill="currentColor"
        />
    </svg>
));
EmojiSadFilledSize32Glyph.displayName = 'EmojiSadFilledSize32Glyph';
